"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
var react_1 = __importStar(require("react"));
var table_styles_1 = require("./table.styles");
var react_table_1 = require("react-table");
var check_cell_1 = require("./TableCells/check_cell");
var Table = function (_a) {
    var _b = _a.initialSortState, initialSortState = _b === void 0 ? { sortBy: [] } : _b, props = __rest(_a, ["initialSortState"]);
    var columns = props.columns, data = props.data, hasRefinementsSet = props.hasRefinementsSet, hasLoadError = props.hasLoadError, setSortState = props.setSortState, NoDataBody = props.NoDataBody, NoResultsBody = props.NoResultsBody, ErrorBody = props.ErrorBody, updateRow = props.updateRow, removeRow = props.removeRow;
    var _c = (0, react_table_1.useTable)({
        updateRow: updateRow,
        removeRow: removeRow,
        columns: columns,
        data: data,
        manualSortBy: true,
        initialState: initialSortState,
        hasRefinementsSet: hasRefinementsSet,
    }, react_table_1.useBlockLayout, react_table_1.useSortBy, react_table_1.useRowSelect), headerGroups = _c.headerGroups, prepareRow = _c.prepareRow, rows = _c.rows, selectedFlatRows = _c.selectedFlatRows, sortBy = _c.state.sortBy;
    (0, react_1.useEffect)(function () {
        if (setSortState) {
            setSortState(sortBy);
        }
    }, [setSortState, sortBy]);
    var parseResult = function () {
        if (!!hasLoadError) {
            return (react_1.default.createElement("tr", null,
                react_1.default.createElement("td", null,
                    react_1.default.createElement(ErrorBody, null))));
        }
        else if (rows.length === 0 && !hasRefinementsSet && !!hasLoadError === false) {
            return (react_1.default.createElement("tr", null,
                react_1.default.createElement("td", null,
                    react_1.default.createElement(NoDataBody, null))));
        }
        else if (rows.length === 0 && hasRefinementsSet && !!hasLoadError === false) {
            return (react_1.default.createElement("tr", null,
                react_1.default.createElement("td", null,
                    react_1.default.createElement(NoResultsBody, null))));
        }
    };
    return (react_1.default.createElement(table_styles_1.StyledTable, null,
        react_1.default.createElement(table_styles_1.TableHead, null, headerGroups
            .filter(function (headerGroup) {
            // Assume bulk header will always be at first level, if applicable
            var hasBulkHeader = headerGroup.headers.some(function (columnInstance) { return columnInstance.originalId === 'bulk'; });
            // Assume there must be a bulk header if there are check headers
            var hasCheckHeader = headerGroup.headers.length === 1 && headerGroup.headers[0].columns.some(function (columnInstance) { return columnInstance.id === 'selection'; });
            return selectedFlatRows.length > 0 || (!hasCheckHeader && data.length !== 0) || hasRefinementsSet || !hasBulkHeader;
        })
            .map(function (headerGroup, key) {
            return (react_1.default.createElement(table_styles_1.TableHeaders, { key: key }, headerGroup.headers.map(function (c) {
                var column = c;
                return (react_1.default.createElement(table_styles_1.TableHeader, __assign({ key: key, flexGrow: column.flexGrow }, column.getHeaderProps(setSortState && (rows.length > 0 || hasRefinementsSet) ? column.getSortByToggleProps() : undefined)), column.render('Header')));
            })));
        })),
        react_1.default.createElement("tbody", null,
            parseResult(),
            rows.map(function (row, rowKey) {
                prepareRow(row);
                return (
                //TODO AAPN-5663 Internalize the disabled checkbox functionality into the CheckCell component
                react_1.default.createElement(table_styles_1.TableRow, { key: rowKey }, row.cells.map(function (cell, cellKey) {
                    var _a;
                    return (react_1.default.createElement(react_1.default.Fragment, null, cell.column.id === 'selection' ? (react_1.default.createElement(table_styles_1.CheckCellWrapper, null,
                        react_1.default.createElement(check_cell_1.CheckCell, { row: row, disabled: (_a = row.original.disabled) !== null && _a !== void 0 ? _a : false }))) : (react_1.default.createElement(table_styles_1.TableCell, __assign({ key: cellKey, flexGrow: cell.column.flexGrow }, cell.getCellProps()), cell.render('Cell')))));
                })));
            }))));
};
exports.Table = Table;
